import { Button } from "react-bootstrap"
import { FiArrowLeft, FiMenu } from "react-icons/fi"
import { useNavigate } from "react-router"

import useT from "utils/hooks/useT"
import isOnMobile from "utils/scripts/isOnMobile"

import HelpSearch from "./HelpSearch"

import "./HelpTopbar.scss"

export default function HelpTopbar({
  onToggleSidebar,
  sidebarOpen,
  sitemap,
  availableAreas,
}) {
  const navigate = useNavigate()
  const { t } = useT("common")

  return (
    <header className="HelpTopbar">
      <div className="HelpTopbar-inner">
        <div className="HelpTopbar-left">
          {isOnMobile && (
            <Button
              variant="light"
              className="HelpTopbar-menuButton"
              onClick={onToggleSidebar}
              aria-label="Toggle navigation"
              aria-expanded={sidebarOpen}
            >
              <FiMenu />
            </Button>
          )}
          <Button variant="link" className="HelpTopbar-back" onClick={() => navigate("/")}>
            <FiArrowLeft /> {t("helpBackToApp")}
          </Button>
          <HelpSearch
            sitemap={sitemap}
            availableAreas={availableAreas}
            placeholder={t("helpSearch")}
          />
        </div>
        <h1 className="HelpTopbar-title">{t("helpAppTitle")}</h1>
        <div className="HelpTopbar-right" />
      </div>
    </header>
  )
}
